import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, Subject } from "rxjs";
import { EstatusJSON } from "../../shared/models/EstatusJSON";
import { IRouteMapRequest } from "../models/IRouteMapRequest";
import { environment } from '../../../../environments/environment';
import { ILocationDTO } from "../models/GeoPosLocations/IGetLastGeoJson";
@Injectable({
  providedIn: "root",
})
export class RouteFilterService {
  
  mapboxToken: string;
  configUrl: string;
  isVisiblePanel$: Subject<boolean> = new Subject<boolean>();
  vehiculo$: Subject<ILocationDTO> = new Subject<ILocationDTO>();

  constructor(private http: HttpClient, private router: Router) {
    this.configUrl = environment.host;
    this.mapboxToken = environment.mapBoxToken;
  }

  getVisibilityPanel(): Observable<boolean> {
    return this.isVisiblePanel$.asObservable();
  }
  setVisibilityPanel(op) {
    this.isVisiblePanel$.next(op);
  }
  getVehiculo(): Observable<ILocationDTO> {
    return this.vehiculo$.asObservable();
  }
  setVehiculo(op) {
    this.vehiculo$.next(op);
  }
  getRouteMapGeoJson(
    routeMapRequest: IRouteMapRequest
  ): any {
    let params = {
      identifier: routeMapRequest.Identifier,
      startDate: routeMapRequest.StartDate,
      endDate: routeMapRequest.EndDate,
    };
    console.log(params);
    return this.http.post<EstatusJSON>(
      this.configUrl + "/api/RouteMap/GetRouteGeoJson",
      params
    );
  }
 

  getRealRouteMap(routeMapRequest: IRouteMapRequest): Observable<EstatusJSON> {
    let params = {
      identifier: routeMapRequest.Identifier,
      startDate: routeMapRequest.StartDate,
      endDate: routeMapRequest.EndDate,
    };
    console.log(params);
    return this.http.post<EstatusJSON>(
      this.configUrl + "/api/RouteMap/GetRoutePoints",
      params
    );
  }

  getList() {
    console.log("/api/Location/GetList/");
    return this.http.get<EstatusJSON>(
      this.configUrl + "/api/Location/GetList",
      {}
    );
  }
  
  findByIdentifier(identifier): any {
    console.log("/api/Location/FindByIdentifier/");
    return this.http.get<EstatusJSON>(
      this.configUrl +
        "/api/Location/FindByIdentifier?identifier=" +
        identifier,
      {}
    );
  }
  
  getRouteData (
    routeMapRequest: IRouteMapRequest
  ): any {
    let params = {
      identifier: routeMapRequest.Identifier,
      startDate: routeMapRequest.StartDate,
      endDate: routeMapRequest.EndDate,
      startHour: routeMapRequest.StartHour
    };
    console.log(params);
    return this.http.post<EstatusJSON>(
      this.configUrl + "/api/RouteMap/GetRouteData",
      params
    );
  }

  getDirectionsAPI(locations): any {
    let headers = new HttpHeaders().set('Access-Control-Allow-Origin', '*'); // create header object
    console.log("https://api.mapbox.com/directions/v5/mapbox/driving/");
    return this.http.get<any>(
      "https://api.mapbox.com/directions/v5/mapbox/driving/" +
        locations +
        "?geometries=geojson&overview=full&access_token=" +
        this.mapboxToken,
      { headers: headers }
    );
  }

  
}
